<div class="container-fluid mt-4">    
    <div class="row">
        <div class="row form-head">
            <div>
                <a (click)="cancel()" class="ac-goback-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                        <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
                    </svg>
                    Go Back </a>
            </div>
        </div>
        <div class="col-lg-12 mt-3">
            <h2 class="ac-heading">Invoice summary</h2>
            <div class="card">
                <div class="card-body">
                    <p class="text-black font-w600">How much do you want to pay?</p>
                    <label class="custom-control-label">
                        <input value="fullAmount" class="custom-control-input me-2" [(ngModel)]="paymentType"
                            name="paymentType" type="radio" /> Pay Total balance amount <span
                            class="text-black font-w600">{{currency| currencySymbol}}{{pendingAmountToPay |
                            number : '1.2-2' }}</span>
                    </label>
                    <br>
                    <label class="custom-control-label">
                        <input value="partialAmount" class="custom-control-input me-2" [(ngModel)]="paymentType"
                            name="paymentType" type="radio" /> Pay partial / Other amount
                    </label>
                </div>
                <p class="text-black font-w600" style="padding: 15px 17px; margin-bottom: -30px;">Invoice details</p>
                <div class="card-body lineheight">
                    <ul class=" list-group mb-3 mt-3 col-sm-8 col-md-7 col-lg-6 ul-left">
                        <li class="row list-group-item d-flex justify-content-between lh-condensed"
                            style="line-height:10px ;" *ngFor="let data of selectedInvoices;let i = index">
                            <div class="col-sm-12 col-md-4">
                                <p class="my-0 fs-16 text-black font-w600">Invoice No.</p>
                                <small class="fs-16">{{data.invoice_id}}</small>
                            </div>
                            <div class="col-sm-12 col-md-4">
                                <p class="my-0 fs-16 text-black font-w600">Due Date</p>
                                <small class="fs-16">{{data.dueDate}}</small>
                            </div>
                            <!-- <span class="text-muted ">{{data.currency| currencySymbol}}{{data.amount | number}}</span> -->
                            <div class="col-sm-12 col-md-4">
                                <p class="my-0 fs-16 text-black font-w600">Balance Due</p>
                                <small class="fs-16">{{data.currency| currencySymbol}}{{data.pending_amount |
                                    number : '1.2-2'}}</small>
                            </div>
                        </li>
                        <li class=" list-group-item d-flex justify-content-between"
                            style="line-height: 20px; margin: 0px -12px; ">
                            <span class="ac-totalblock fs-16 text-black font-w600">Total {{currency|currencySymbol}}</span>
                            <input type="text" [value]="pendingAmountToPay | number : '1.2-2'" disabled="true"
                                class="inputbox form-control text-muted" style="text-align: right;font-weight: 600; height: 30px;
                                margin: 4px 0px;">
                        </li>

                    </ul>

                    <ul class="list-group mb-3 mt-3 lineheight" *ngIf="paymentType == 'partialAmount'">
                        <li class="list-group-item d-flex justify-content-between"
                            *ngFor="let data of selectedInvoices;let i = index">
                            <!-- <span class="ac-totalblock" style="width: 40%;">Invoice {{data.invoice_id}}</span> -->
                            <span class="ac-mob-lineh" style="margin: 5px 3px 0px 0px;">{{currency|
                                currencySymbol}}</span>
                            <input type="number" pattern="/^[0-9]+(\.[0-9]{1,2})?$/" step="any" required name="amount"
                                id="editamount" [(ngModel)]="data.editedAmountToPay" [value]="data.editedAmountToPay"
                                onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)"
                                class="inputbox form-control ac-mob-mt"
                                style="height: 30px;text-align: right; margin: 9px 2px;">
                            <br>
                            <div *ngIf="0>=data.editedAmountToPay" class="amount-error">
                                Amount must be greater than 0
                            </div>
                        </li>

                        <li class="list-group-item d-flex justify-content-between" style="line-height:30px ;">
                            <!-- <span class="ac-totalblock">Total ($)</span> -->
                            <span style="margin: 5px 3px 0px 0px;">{{currency| currencySymbol}}</span>
                            <input type="text" [value]="pendingAmountToPay | number:'1.2-2'" [ngModel]="getTotalAmount() | number:'1.2-2'" disabled="true" class="inputbox form-control" style="text-align: right;font-weight: 600; height: 30px; margin: 4px 0px;">
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <button type="button" class="btn ac-btn-outline-primary ac-butncancel mr-3 "
                    (click)="cancel()">Cancel</button>
                <button type="button" class="btn ac-btn-primary  mb-sm-0 mb-2"
                    (click)="payBills()">Continue</button>
            </div>
        </div>
    </div>
</div>
